module.exports = __webpack_public_path__ + "img/editor_preview-map.abc1bc9.webp";